import Button from "@/components/ui/button";
import Textarea from "@/components/ui/textarea";
import StepLayout from "../step-layout";
import { useFeedbackFlow } from "../../hooks/use-feedback-flow";

export default function StepNegativeFeedback() {
	const { data, setNegativeFeedback, nextStep, canProceed } = useFeedbackFlow();

	const handleSubmit = () => {
		if (canProceed()) {
			nextStep();
		}
	};

	return (
		<StepLayout
			header={
				<div>
					<h1 className="text-2xl font-semibold text-primary mb-2">Sorry to hear that!</h1>
					<p className="text-secondary">We truly value your feedback. Please share what we could do better so we can improve your experience.</p>
				</div>
			}
			content={
				<div className="text-left">
					<Textarea
						sizeVariant="large"
						label="Your feedback"
						value={data.negativeFeedback}
						onChange={(e) => setNegativeFeedback(e.target.value)}
						placeholder="Tell us what could be improved..."
						rows={5}
						required
					/>
				</div>
			}
			footer={
				<div className="flex justify-center">
					<Button onClick={handleSubmit} disabled={!canProceed()} variant="brand" className="w-full">
						Submit Feedback
					</Button>
				</div>
			}
		/>
	);
}
